export const init = () => {
  /* SHOPPING TOOL - TG & PUSH */

  if (!['list', 'internal_search', 'product'].includes(tc_vars.env_template))
    return;

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;
  const lock = AnalyticsConstants.shoppingtool.lock;

  // ShoppingTool
  const shoppingtool = fwk.shoppingtool.get();
  let stType = 'merchandising';

  if (shoppingtool && shoppingtool.st) stType = shoppingtool.st;

  // Events name
  const nameEventSpotlight = 'eventSpotlight';
  const nameEventSpotlightFloor = 'eventSpotlightFloor';
  const nameEventListingProduct = 'eventListingProduct';

  const trackerName = AnalyticsConstants.trackers.product.productList.name;
  if (!fwk.trackers.list[trackerName]) return;

  // Get events
  const eventSpotlight =
    fwk.trackers.list[trackerName].events[nameEventSpotlight];
  const eventSpotlightFloor =
    fwk.trackers.list[trackerName].events[nameEventSpotlightFloor];
  const eventListingProduct =
    fwk.trackers.list[trackerName].events[nameEventListingProduct];

  if (eventSpotlight) {
    // Click on SPOTLIGHT products
    eventSpotlight.postAction($element => {
      const sticker = fwk.utils.pagelist.getStickerValue(
        fwk.utils.pagelist.getStickerSpotlight()
      );
      const model = fwk.utils.pagelist.getModel($element);

      const slide = $element.closest('.pl-element.slick-slide');
      const position = slide.data('slick-index') + 1;

      const stDetail = `${sticker}position${sep}${position}`;
      fwk.shoppingtool.set(
        `${stType}-spotlightfloor-top`,
        stDetail,
        fwk.colorama.getDetail(model.id)
      );
    });
  }

  if (eventSpotlightFloor) {
    // Click on SPOTLIGHT FLOOR products
    eventSpotlightFloor.postAction($element => {
      const sticker = fwk.utils.pagelist.getStickerValue(
        fwk.utils.pagelist.getSticker($element)
      );
      const model = fwk.utils.pagelist.getModel($element);

      const product = $element.closest('.product');
      const position = $('.product').index(product) + 1;
      const wide = product.hasClass('wide') ? `${sep}wide` : '';

      const stDetail = `${sticker}position${sep}${position}${wide}`;
      fwk.shoppingtool.set(
        `${stType}-spotlightfloor-bottom`,
        stDetail,
        fwk.colorama.getDetail(model.id)
      );
    });
  }

  if (eventListingProduct) {
    // Click on LISTING products
    eventListingProduct.postAction($element => {
      const actualShoppingtool = fwk.shoppingtool.getActual();
      if (actualShoppingtool && Object.keys(actualShoppingtool).length > 0) {
        const model = fwk.utils.pagelist.parseProduct($element);
        fwk.shoppingtool.set(actualShoppingtool.st, actualShoppingtool.std, fwk.colorama.getDetail(model.id));
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-tg-push.js